import React from 'react';
import { Routes, Route, useNavigate } from "react-router-dom";
import LoginLayout from '../Layout/Loginindex';
import Logout from '../Components/Logout';
import Login from '../Components/Login/Login';
import Register from '../Components/Login/Register'; 
import AccountRegister from '../Components/Login/AccountRegister'
import EmailVerification from '../Components/Login/EmailVerification'

export default function GuestRoutes(){
  const navigation = useNavigate();
  //let auth = Auth();
  

    return(
        <Routes >
          <Route element={<LoginLayout />}>
            <Route path="/" element={<Login />} />
            <Route path="/Login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/accountregister" element={<AccountRegister />} />
            <Route path="/emailactivation/:actcode/:email" element={<EmailVerification />} />
          </Route>
      </Routes>
    )
  
}